import { Box, Link, Paper, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import styled from "styled-components/macro";
import img from "../../../assets/images/login-form.jpg";
import useAppDispatch from "../../../redux/useAppDispatch";
import RegisterForm from "../components/RegisterForm";
import { closeSignupModal } from "../slice";

const Picture = styled("picture")`
  display: block;
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const RegisterContent = () => {
  const dispatch = useAppDispatch();
  const handleCloseModal = () => dispatch(closeSignupModal());

  return (
    <Paper
      sx={{
        display: "flex",
        maxWidth: 1000,
        width: "100%",
        minHeight: {
          xs: 0,
          sm: 630,
        },
        borderRadius: 2.5,
        bgcolor: "#fff",
      }}
    >
      <Box
        p={5}
        pb={10}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: {
            xs: "100%",
            sm: "70%",
            md: "50%",
          },
        }}
      >
        <Box textAlign="center">
          <Typography variant="h2" component="h2" mb={2}>
            Velkommen til Nextkey
          </Typography>
          <Typography fontWeight={500}>
            Opret en bruger eller{" "}
            <Link component={RouterLink} to="/auth" onClick={handleCloseModal}>
              login
            </Link>
          </Typography>
        </Box>
        <Box maxWidth={280} width="100%" mx="auto" mt={10}>
          <RegisterForm />
        </Box>
      </Box>
      <Box
        sx={{
          display: {
            xs: "none",
            sm: "block",
          },
          width: {
            xs: "none",
            sm: "30%",
            md: "50%",
          },
          borderRadius: 2.5,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          overflow: "hidden",
        }}
      >
        <Picture>
          <img src={img} alt="" />
        </Picture>
      </Box>
    </Paper>
  );
};

export default RegisterContent;
